import { render, staticRenderFns } from "./DeregisterTag.vue?vue&type=template&id=d9857aac&"
import script from "./DeregisterTag.vue?vue&type=script&lang=js&"
export * from "./DeregisterTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports